import { Controller } from "@hotwired/stimulus";
import { WebAuthnSigner } from "@dfns/sdk-browser";
import channelService from "../../../services/ChannelService";
import httpService from "../../../services/HttpService";
import { emitCheckoutEvent } from "../../../services/checkoutEvents";
import { storage } from "../../../storageconstants";
import { debugError, debugLog } from "../../../utils";

export default class extends Controller {
  static targets = ["submitButton"];

  static values = {
    permitid: Number,
    tokensymbol: String,
    challenge: String,
    typeddata: String,
    address: String,
    session: String,
    keycredential: Boolean,
  }

  async connect() {
    this.hideLoadingScreen();

    this.attestation = null;

    this.domain = JSON.parse(sessionStorage.getItem(storage.DOMAIN));
    this.challenge = JSON.parse(this.challengeValue);
    this.typedData = JSON.parse(this.typeddataValue);
    this.address = this.addressValue;
    this.session = this.sessionValue;
    this.keyCredential = this.keycredentialValue;
  }

  async handleSignChallenge() {
    try {
      if (!this.challenge) throw new Error("No challenge available to sign");
      if (!this.domain)    throw new Error("Domain data not available");

      if (this.keyCredential) {
        debugLog("Using keycredential for signing");

        let signResonse = await httpService.post(`/sign/`, {
          challenge: this.challenge,
          session: this.session
        });

        if (signResonse.error) {
          debugError(signResonse.error);
          throw new Error(signResonse.error);
        }

        debugLog("KeyCredential signing successful:", signResonse.data);

        this.attestation = signResonse.data;
      } else {
        debugLog("Starting WebAuthn signing for stored challenge");

        const webauthn = new WebAuthnSigner({
          relyingParty: {
            id: this.domain.domain,
            name: this.domain.company,
          },
        });

        this.attestation = await webauthn.sign(this.challenge);
      }

      // Signature obtained (KMS or WebAuthn) — one step before completion.
      // network/amount_usd are filled backend-side from the session.
      emitCheckoutEvent("checkout_payment_signed", {
        asset: this.tokensymbolValue || "",
        signing_method: this.keyCredential ? "kms_key_credential" : "dfns_passkey",
      });

      this.showLoadingScreen();
      this.proceedToPurchase();
    } catch (error) {
      debugLog("Error during WebAuthn signing:", error);
    }
  }

  async proceedToPurchase() {
    const data = this.typedData;
    
    data.session = this.session;
    data.address = this.address;
    data.challengeIdentifier = this.challenge.challengeIdentifier;
    data.firstFactor = this.attestation;
    data.permitId = this.permitidValue;
    data.tokenSymbol = this.tokensymbolValue;

    debugLog("payment/ endpoint data:", data);

    try {
      const res = await httpService.post(`/payment/`, data);

      switch (res.type) {
        case "channel":
          channelService.connect(res.data);
          break;
        case "html":
          Turbo.renderStreamMessage(res.data);
          if (res.channel) channelService.connect(res.channel);
          break;
        case "redirect":
          Turbo.visit(res.data);
          break;
      }
    } catch (error) {
      debugLog("error", error.message);
    }
  }

  showLoadingScreen() {
    this.dispatch("showLoadingScreen", { detail: { text: "Almost There..." } });
  }

  hideLoadingScreen() {
    this.dispatch("hideLoadingScreen");
  }
}
